export function getIndeterminateMinimumDurationMs() {
    return 1000;
}
